import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=6735afab&scoped=true&"
import script from "./OrderPreview.vue?vue&type=script&lang=js&"
export * from "./OrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=6735afab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735afab",
  null
  
)

export default component.exports